<router-outlet></router-outlet>
@if (!chatStore.isHidden()) {
    <app-joii-chat/>
}